import moment from 'moment'
import { cn } from 'app/lib/utils'
import { ContactJson } from 'app/types/entities'
import { hygieneDaysUntilDue, hygieneDueOn } from './queueRegistry'

/**
 * The recall as two dates with the wait between them, sized for a card.
 * Draws nothing without a last cleaning.
 */
export function RecallTimeline({ contact }: { contact: ContactJson }) {
  const last = contact.lastHygieneDate ? moment.utc(contact.lastHygieneDate) : undefined
  const dueOn = hygieneDueOn(contact)
  if (!last?.isValid() || !dueOn) return null
  const daysOut = hygieneDaysUntilDue(contact) ?? 0
  const late = daysOut < 0
  const due = moment.utc(dueOn)

  const thisYear = moment.utc().year()
  const stop = (date: moment.Moment) => date.format(date.year() === thisYear ? `MMM D` : `MMM D, YYYY`)

  return (
    <div className="flex min-w-0 items-center gap-2 text-body-xs">
      <span className="inline-flex shrink-0 items-center gap-1.5 text-minimal">
        <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-(--line-strong)" />
        {stop(last)}
      </span>
      <span
        className={cn(`min-w-[1.5rem] flex-1 border-t border-dashed`, late ? `border-red-300` : `border-default`)}
      />
      <span
        className={cn(`inline-flex shrink-0 items-center gap-1.5 font-medium`, late ? `text-red-600` : `text-strong`)}
      >
        {/* Hollow while the due date is still ahead, filled once it has gone past. */}
        <span
          className={cn(
            `h-2 w-2 shrink-0 rounded-full border`,
            late ? `border-red-500 bg-red-500` : `border-(--fg-minimal) bg-surface`,
          )}
        />
        {late ? `Was due ${stop(due)}` : `Due ${stop(due)}`}
      </span>
    </div>
  )
}
